import type { User } from "@firebase/auth";
import { auth } from "./firebase";
import { api } from "./api";

export function configureAuthEmailLanguage() {
  if (auth) auth.languageCode = localStorage.getItem("twm-admin-lang") === "en" ? "en" : "el";
}
export function authEmailSettings(destination: "/billing" | "/login") {
  // The continue destination is always our own origin, never a user-supplied URL.
  return { url: new URL(destination, window.location.origin).href, handleCodeInApp: false };
}
export async function sendKateVerificationEmail(user: User) {
  const token = await user.getIdToken();
  await api.sendVerificationEmail(token, localStorage.getItem("twm-admin-lang") === "en" ? "en" : "el");
}
